import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import reportWebVitals from './reportWebVitals';
import Router from './route/Router';
import { BrowserRouter } from "react-router-dom";
import { ConfigProvider } from "antd";
import zhCN from 'antd/locale/zh_CN';
import 'globalthis/auto'
import './index.less'

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
	<ConfigProvider locale={zhCN}>
		<BrowserRouter>
			<Suspense fallback={<div></div>}>
				<Router />
			</Suspense>
		</BrowserRouter>
	</ConfigProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
